import React from "react";
import CrossIcon from "../../../assets/icons/cross.svg";
import ReactModal from "react-modal";
import {useSelector} from "react-redux";
import LoaderLinear from "../../utilites/Loader/Loader";

export const IndexModal = ({isOpen, stateModalHandler, submitDirectories}) => {
    const {isLoading} = useSelector(({directories}) => directories)
    return (
        <ReactModal
            className="modal-container affiliates-modal"
            overlayClassName="modal-overlay"
            isOpen={isOpen}>
            <LoaderLinear isLoading={isLoading}/>
            <div className="modal-header indexModal-containerModal">
                <h2>Проиндексировать ?</h2>
                <button
                    className="button-icontrigger modal-closetrigger"
                    onClick={stateModalHandler}>
                    <span className="icon">
                         <CrossIcon/>
                    </span>
                </button>
            </div>
            <div className="modal-footer">
                <button className={ isLoading ? "button-light" : "button"}
                        onClick={submitDirectories}
                        disabled={isLoading}>Да</button>
                <button className="button-light" onClick={stateModalHandler}>
                    Нет
                </button>
            </div>
        </ReactModal>
    )
}